// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YxzH4","fullView":"styles_fullView__3vf0k"};